import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import perusahaanSubkonService from "../../../services/ref/perusahaanSubkonService";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import Cookies from "js-cookie";

export const initialState = {
    loading_perusahaan_subkon: false,
    data_perusahaan_subkon: [],
    showMessage:false,
    message:'',
}

export const getDataPerusahaanSubkon = createAsyncThunk('perusahaan_subkon/data',async (data, { rejectWithValue }) => {
    try {
        const response = await perusahaanSubkonService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        // swallow
    }
})

export const perusahaanSubkonSlice = createSlice({
    name: 'perusahaan_subkon',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_perusahaan_subkon = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPerusahaanSubkon.fulfilled, (state, action) => {
                state.loading_perusahaan_subkon = false
                state.data_perusahaan_subkon = action.payload??[]
            })
            .addCase(getDataPerusahaanSubkon.pending, (state) => {
                state.loading_perusahaan_subkon = true
            })
            .addCase(getDataPerusahaanSubkon.rejected, (state, action) => {
                state.loading_perusahaan_subkon = false
                state.data_perusahaan_subkon = action.payload
            })
    },
})

export const { showLoading } = perusahaanSubkonSlice.actions

export default perusahaanSubkonSlice.reducer
